import { Injectable } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { SectorService } from '@services/sector/sector.service';
import { SagaSettingsService } from '@services/settings';
import { filter, first } from 'rxjs';

export interface CardGroup {
  name: string;
  cards: CallCard[];
  groupFilter(callcard: CallCard): boolean;
  groupSorter?(a: CallCard, b: CallCard): number;
  hideIfEmpty?: boolean;
  cssClass?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CallCardGroupsService {
  private readonly OTHER_CARDS_GROUP_NAME: string = 'Mobile.OtherCardsTitle';
  private readonly MY_SECTOR_CARDS_GROUP_NAME: string = 'Mobile.MySectorCardsTitle';
  private readonly PREASSIGNED_CARDS_GROUP_NAME: string = 'Mobile.PreassignedCardsTitle';

  cardGroups: CardGroup[] = [{ name: this.OTHER_CARDS_GROUP_NAME, cards: [], groupFilter: () => true }];

  myCardCss: string = '';
  showCallCardCount: boolean = false;

  constructor(private sagaSettings: SagaSettingsService, private sectorService: SectorService) {}

  setup(grouping: string = '') {
    this.sagaSettings.$ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => (this.showCallCardCount = this.sagaSettings.getValue('SagaMobileWebClient.ShowCallCardCount')));

    switch (grouping) {
      case 'ShowMySector':
        this.myCardCss = 'myCard';
        this.cardGroups = [
          { name: this.MY_SECTOR_CARDS_GROUP_NAME, cards: [], groupFilter: callcard => this.isInMySector(callcard), cssClass: 'mySector' },
          { name: this.OTHER_CARDS_GROUP_NAME, cards: [], groupFilter: callcard => !this.isInMySector(callcard), cssClass: 'otherSector' }
        ];
        break;

      case 'ShowPreassigned':
        this.cardGroups = [
          {
            name: this.PREASSIGNED_CARDS_GROUP_NAME,
            cards: [],
            groupFilter: callcard => this.isPreassigned(callcard),
            groupSorter: (a, b) => this.preassignedSorter(a, b),
            hideIfEmpty: true
          },
          { name: this.OTHER_CARDS_GROUP_NAME, cards: [], groupFilter: callcard => !this.isPreassigned(callcard) }
        ];
        break;
    }
  }

  private isInMySector(callcard: CallCard): boolean {
    return callcard.Owner === this.sectorService.myZone.ParentId;
  }

  private isPreassigned(callcard: CallCard): boolean {
    return callcard.preattribution?.jsonData?.Status == 0 || false;
  }

  private preassignedSorter(a: CallCard, b: CallCard): number {
    const order1: number = a.preattribution?.jsonData?.Order || 0;
    const order2: number = b.preattribution?.jsonData?.Order || 0;

    return order1 - order2;
  }

  refresh(callcards: CallCard[]) {
    this.cardGroups.forEach(cardGroup => {
      cardGroup.cards = callcards.filter(cardGroup.groupFilter);
      if (cardGroup.groupSorter) {
        cardGroup.cards.sort(cardGroup.groupSorter);
      }
    });
  }
}
